module.exports = __webpack_public_path__ + "static/img/sans.db4000c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sans.jpg
// module id = a6N2
// module chunks = 0